import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useAuthContext } from '../../auth/hooks';
import { hasPermission } from '../../utils/helpers';
// ----------------------------------------------------------------------

const MAIN_NAV_ITEMS = [
  {
    title: 'Customer Card',
    icon: 'ic:baseline-person',
    path: '/customer-card',
    permission: 'BO_CAN_VIEW_CUSTOMERS', // same as Customer
  },
  {
    title: 'Customer',
    icon: 'ic:outline-badge',
    path: paths.customer.root,
    permission: 'BO_CAN_VIEW_CUSTOMERS',
  },
  {
    title: 'Bundles',
    icon: 'ic:outline-layers',
    path: paths.bundle.root,
    permission: 'BO_CAN_VIEW_BUNDLES',
  },
  {
    title: 'B2B Vendors',
    icon: 'ic:outline-storefront',
    path: paths.b2b.root,
    permission: 'BO_CAN_VIEW_B2BS',
  },
  {
    title: 'Subscription',
    icon: 'ic:outline-event-repeat',
    path: paths.subscription.root,
    permission: 'BO_CAN_VIEW_SUBSCRIPTIONS',
  },
  // {
  //   title: 'Vendor Activations',
  //   icon: 'ic:outline-description',
  //   path: paths.vendorActivations.root,
  //   permission: 'BO_CAN_VIEW_PLATFORM_ACTIVATIONS',
  // },
  {
    title: 'Setanta Activations',
    icon: 'ic:outline-manage-search',
    path: paths.setantaActivations.root,
    permission: 'BO_CAN_VIEW_VENDOR_INFO',
  },
  {
    title: 'Cancellation Schedule',
    icon: 'ic:outline-cancel',
    path: paths.cancellationSchedule.root,
    permission: 'BO_CAN_VIEW_CANCELATION_SCHEDULE',
  },
  {
    title: 'Downgrade Schedule',
    icon: 'ic:outline-arrow-circle-down',
    path: paths.downgradeSchedule.root,
    permission: 'BO_CAN_VIEW_DOWNGRADE_SCHEDULE',
  },
  {
    title: 'Customer Blacklist',
    icon: 'ic:outline-cancel',
    path: paths.customerBlacklist.root,
    permission: 'BO_CAN_VIEW_BLACK_LIST',
  },
  {
    title: 'Change Logs',
    icon: 'ic:outline-event-note',
    path: paths.changeLog.root,
    permission: 'BO_CAN_VIEW_CHANGE_LOGS',
  },
  {
    title: 'Netflix Initiated Changes',
    icon: 'ic:outline-video-settings',
    path: paths.netflixInitiatedChanges.root,
    permission: 'BO_CAN_VIEW_NETFLIX_SYNC_REQUESTS'
  }
];

const ADMIN_NAV_ITEMS = [
  {
    title: 'Users',
    icon: 'ic:outline-group',
    path: paths.internalUser.root,
    permission: 'BO_CAN_VIEW_USERS',
  },
  {
    title: 'Roles',
    icon: 'ic:outline-shield',
    path: paths.role.root,
    permission: 'BO_CAN_VIEW_ROLES',
  },
];

const OTHER_NAV_ITEMS = [
  {
    title: 'apiCertification',
    permission: 'BO_CAN_VIEW_B2B_CERTIFICATES',
    path: paths.apiCertification.root,
  },
];

export function useNavData() {
  const { user } = useAuthContext();

  const mainNavItems = useMemo(
    () => MAIN_NAV_ITEMS.filter(({ permission }) => !permission || hasPermission(user, permission)),
    [user]
  );

  const adminNavItems = useMemo(
    () => ADMIN_NAV_ITEMS.filter(({ permission }) => hasPermission(user, permission)),
    [user]
  );

  return [
    { items: mainNavItems },
    ...(adminNavItems.length
      ? [{ subheader: 'Admin Options', miniSubheader: 'Admin', items: adminNavItems }]
      : []),
  ];
}

// Path after login
let PATH_AFTER_LOGIN = null;
export const setPathAfterLogin = (user) => {
  const item = [...MAIN_NAV_ITEMS, ...OTHER_NAV_ITEMS, ...ADMIN_NAV_ITEMS].find(({ permission }) =>
    hasPermission(user, permission)
  );
  PATH_AFTER_LOGIN = item?.path || '/customer';
};
export const getPathAfterLogin = () => PATH_AFTER_LOGIN;
